"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ThemeProvider = require("../ThemeProvider");
var _ViewportProvider = require("../ViewportProvider");
var _utils = require("../utils");
var _List = _interopRequireDefault(require("../List"));
var _StackWrap = _interopRequireDefault(require("../StackView/StackWrap"));
var _QuickLinksCard = _interopRequireDefault(require("./QuickLinksCard"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * QuickLinks renders a list of interactive items. How it renders these items depends on theme options:
 *  - If the theme returns `list` token as true, it renders an ordered list based on List
 *  - If the theme returns `button` token as true and `list` as false, it renders a wrapping horizontal bar of buttons
 *  - If the theme returns `card` token as true, it wraps the above with a `Card`.
 */const QuickLinks = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    tokens,
    variant,
    listTokens,
    cardTokens,
    children,
    tag = 'ul',
    ...rest
  } = _ref;
  const viewport = (0, _ViewportProvider.useViewport)();
  const {
    dividers,
    list,
    card,
    stackSpace,
    stackGap,
    stackJustify
  } = (0, _ThemeProvider.useThemeTokens)('QuickLinks', tokens, variant, {
    viewport
  });
  const content = list && /*#__PURE__*/(0, _jsxRuntime.jsx)(_List.default, {
    ref: ref,
    tokens: listTokens,
    showDivider: dividers,
    tag: tag,
    ...rest,
    children: children
  }) || /*#__PURE__*/(0, _jsxRuntime.jsx)(_StackWrap.default, {
    space: stackSpace,
    gap: stackGap,
    tokens: {
      justifyContent: stackJustify
    },
    tag: tag,
    ...rest,
    children: children
  });
  return card ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_QuickLinksCard.default, {
    tokens: cardTokens,
    children: content
  }) : content;
});
QuickLinks.displayName = 'QuickLinks';
QuickLinks.propTypes = {
  tokens: (0, _utils.getTokensPropType)('QuickLinks'),
  /**
   * Custom tokens override for `Card`
   */
  cardTokens: (0, _utils.getTokensPropType)('Card'),
  /**
   * Custom tokens override for `QuickLinksList`
   */
  listTokens: (0, _utils.getTokensPropType)('QuickLinksList'),
  /**
   * The HTML tag to render the list as
   */
  tag: _propTypes.default.string,
  variant: _utils.variantProp.propType,
  children: _propTypes.default.node
};
var _default = exports.default = QuickLinks;